export const aplicarMascaraProcessoProtocolo = (valor, digitosAntesBarra = 7, digitosDepoisBarra = 4) => {
    if (!valor) return ''
    
    // Remove todos os caracteres não numéricos
    const numeros = valor.replace(/\D/g, '')
    
    // Limita o número total de dígitos
    const maxDigitos = digitosAntesBarra + digitosDepoisBarra
    const numerosLimitados = numeros.slice(0, maxDigitos)
    
    // Aplica a máscara dinamicamente
    if (numerosLimitados.length <= digitosAntesBarra) {
        return numerosLimitados
    } else {
        const antesBarra = numerosLimitados.slice(0, digitosAntesBarra)
        const depoisBarra = numerosLimitados.slice(digitosAntesBarra)
        return `${antesBarra}/${depoisBarra}`
    }
}

export const handleMascaraProcessoProtocolo = (valor, digitosAntesBarra = 7, digitosDepoisBarra = 4) => {
    return aplicarMascaraProcessoProtocolo(valor, digitosAntesBarra, digitosDepoisBarra)
}